import apolloClient from 'api/apolloClient';
import { INVITE_EMPLOYEES_TO_GROUP } from 'api/queries/userService';

export async function inviteEmployeesToGroup(groupId: string, employees: Record<string, string>[]): Promise<boolean> {
  const result = await apolloClient.mutate<{
    inviteEmployeesToGroup: boolean;
  }>({
    mutation: INVITE_EMPLOYEES_TO_GROUP,
    variables: { groupId, employees },
  });
  return result.data!.inviteEmployeesToGroup;
}
